/**
 * Created by Kotkin on 27.03.2018
 */

// https://gist.github.com/kostasx/c89c4d6e8ba2921cb5dc4fc508bc1a8c

const parseVideo = (url) => {
  // - Supported YouTube URL formats:
  //   - http://www.youtube.com/watch?v=My2FRPA3Gf8
  //   - http://youtu.be/My2FRPA3Gf8
  //   - https://youtube.googleapis.com/v/My2FRPA3Gf8
  // - Supported Vimeo URL formats:
  //   - http://vimeo.com/25451551
  //   - http://player.vimeo.com/video/25451551
  // - Also supports relative URLs:
  //   - //player.vimeo.com/video/25451551
  // - DailyMotion
  //   - http://www.dailymotion.com/video/x6ga7eg

  url.match(/(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com)|dailymotion.com)\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\S+)?/);

  let type = null;
  if (RegExp.$3.indexOf('youtu') > -1) {
    type = 'youtube';
  } else if (RegExp.$3.indexOf('vimeo') > -1) {
    type = 'vimeo';
  } else if (RegExp.$3.indexOf('dailymotion') > -1) {
    type = 'dailymotion';
  }

  return {
    type,
    id: RegExp.$6
  };
};

const createVideo = (url, width, height) => {
  // Returns an iframe of the video with the specified URL.
  const videoObj = parseVideo(url);
  let src = url;
  if (videoObj.type === 'youtube') {
    src = `//www.youtube.com/embed/${videoObj.id}`;
  } else if (videoObj.type === 'vimeo') {
    src = `//player.vimeo.com/video/${videoObj.id}`;
  } else if (videoObj.type === 'dailymotion') {
    src = `//www.dailymotion.com/embed/video/${videoObj.id}`;
  }

  return (
    `<span class="postVideo"><span class="postVideoContent"><iframe src="${src}" title="video" allow="encrypted-media" width="${width}" height="${height}" allowFullScreen /></span></span>`
  );
};

export default createVideo;
